import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class GoogleMaps extends Component {
  static defaultProps = {
    center: {
      lat: 59.95,
      lng: 30.33
    },
    zoom: 11
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div style={{ height: '600px', width: '100%' }}>
        <iframe width='100%' height='500px' id='mapcanvas' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39410.6461652779!2d-1.805983658540344!3d51.876193566325206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4871259c974efdd3%3A0x62b46d705469ad33!2sBourton-on-the-Water%2C%20Cheltenham!5e0!3m2!1sen!2suk!4v1580055145000!5m2!1sen!2suk" frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe>
      </div>
    );
  }
}

export default GoogleMaps;

// 
//         <GoogleMapReact
//           bootstrapURLKeys={{ key: 'AIzaSyBgwCI4iXB3PTokqwgG1qnSj6g8phryhP4 ' }}
//           defaultCenter={this.props.center}
//           defaultZoom={this.props.zoom}
//         >
//           <AnyReactComponent
//             lat={59.955413}
//             lng={30.337844}
//             text="My Marker"
//           />
//         </GoogleMapReact>